module.exports = __webpack_public_path__ + "static/speaking-our-minds-159f495b3e0164d58167f130107ff7f0.jpg";